export default "__VITE_ASSET__nw6FcVyu__"